module.exports = __webpack_public_path__ + "static/media/slider4.630f1c59.jpg";